import { sharedTracker } from '../Tracker';
import events from '../events';

export const trackWorkspaceDeletion = workspace => sharedTracker
	.trackWorkspaceAction( {
		action: events.workspace.WORKSPACE_DELETED,
		label: workspace.name
	} );

export const trackTransferWorkspaceOwnership = () => sharedTracker
	.trackWorkspaceAction( {
		action: events.workspace.WORKSPACE_OWNERSHIP_TRANSFERRED
	} );

export const trackWorkspaceInvite = ( { role, workspaceID, seatsAssigned } ) => sharedTracker
	.trackWorkspaceAction( {
		action: events.workspace.WORKSPACE_MEMBER_INVITED,
		role,
		workspace_id: workspaceID,
		seats_assigned: seatsAssigned
	} );

export const trackWorkspaceRoleEdit = workspaceRole => sharedTracker
	.trackWorkspaceAction( {
		action: events.workspace.WORKSPACE_ROLE_EDITED,
		label: workspaceRole
	} );

export const trackWorkspaceBillingEdit = () => sharedTracker
	.trackWorkspaceAction( {
		action: events.workspace.WORKSPACE_BILLING_EDITED
	} );

export const trackWorkspaceInvoiceOpen = () => sharedTracker
	.trackWorkspaceAction( {
		action: events.workspace.INVOICE_OPENED
	} );

export const trackProjectAccessedAsManager = ( { projectID } ) => sharedTracker
	.trackWorkspaceAction( {
		action: events.workspace.PROJECT_ACCESSED_AS_MANAGER,
		project_id: projectID
	} );

export const trackWorkspaceLogoUploaded = ( { workspaceID } ) => sharedTracker
	.trackWorkspaceAction( {
		action: events.workspace.WORKSPACE_LOGO_UPLOADED,
		workspace_id: workspaceID
	} );

export const trackWorkspaceLogoRestored = ( { workspaceID } ) => sharedTracker
	.trackWorkspaceAction( {
		action: events.workspace.WORKSPACE_LOGO_RESTORED,
		workspace_id: workspaceID
	} );
